const LEGACY_PREFIX = 'legacy:'

// Старые бюджеты пока существуют как stages, новые — как budgets.
export function buildActBudgetOptions(budgets = [], stages = []) {
  const linked = new Set(budgets.map((budget) => String(budget.legacy_stage_id || '')))
  const stagesById = new Map(stages.map((stage) => [String(stage.id), stage]))
  const currentBudgets = budgets.map((budget) => {
    const stage = stagesById.get(String(budget.legacy_stage_id))
    const stageType = String(budget.stage_type || stage?.type || '').trim()
    const distributionType = String(budget.distribution_type || stage?.distribution_type || '').trim()
    const name = String(budget.name || '').trim()
    // Синхронизация могла обновить тип распределения, сохранив старый автозаголовок.
    // Пользовательские названия оставляем как есть.
    if (stageType && distributionType && (!name || name.startsWith(`${stageType} — `))) {
      return { ...budget, name: stageType === distributionType ? stageType : `${stageType} — ${distributionType}` }
    }
    return budget
  })
  return [...currentBudgets, ...stages
    .filter((stage) => !linked.has(String(stage.id)))
    .map((stage) => ({
      id: `${LEGACY_PREFIX}${stage.id}`,
      name: stage.distribution_type || stage.name || stage.type || stage.id,
      legacy_stage_id: stage.id,
    }))]
}

export function actBudgetPayload(data) {
  const payload = { ...data }
  const value = String(payload.budget_id || '')
  if (value.startsWith(LEGACY_PREFIX)) {
    payload.stage_id = value.slice(LEGACY_PREFIX.length)
    payload.budget_id = null
  } else if (value) {
    // Сервер сам определяет legacy stage нового бюджета.
    delete payload.stage_id
  } else {
    payload.stage_id = null
  }
  return payload
}
